import {getLayerByName} from "@/helpers/ol/ol-layer-helper.js";
import {addServiceWmsByUrl} from "@/modules/ol/service/ol-service-wms.js";
import {getInnerHtmlByText} from "@/helpers/element-helper.js";

export function initDataTablePlugin(data, visible = true, service = '') {

    const layerName = getInnerHtmlByText(data[2], 2)
    const layer = getLayerByName(layerName, false)

    if(layer) {
        layer.setVisible(visible)
   } else {
        addServiceWmsByUrl(window.map, service, layerName, 0.5)
    }
}
